export const gamePage = `<div id="container" class="container">
  <!-- 3d world-->
  <canvas class="webgl"></canvas>

  <!-- ui -->
  <div class="portrait"></div>

  <div class="quickBar" id="quickBar">
    <div class="actionContainer">
      <div class="action" id="actionOne">
        <p class="actionNum">1</p>
      </div>
      <div class="action" id="actionTwo">
        <p class="actionNum">2</p>
      </div>
      <div class="action" id="actionThree">
        <p class="actionNum">3</p>
      </div>
      <div class="action" id="actionFour">
        <p class="actionNum">4</p>
      </div>
      <div class="action" id="actionFive">
        <p class="actionNum">5</p>
      </div>
      <div class="action" id="actionSix">
        <p class="actionNum">6</p>
      </div>
      <div class="action" id="actionSeven">
        <p class="actionNum">7</p>
      </div>
      <div class="action" id="actionEight">
        <p class="actionNum">8</p>
      </div>
    </div>
  </div>

  <div class="optionsBar">
    <div class="optionsContainer">
      <div class="setting" id="settingOne">
        <p>Character Screen</p>
      </div>
      <div class="setting" id="settingTwo">
        <p>Crafting</p>
      </div>
      <div class="setting" id="settingThree">
        <p>Bags</p>
      </div>
      <div class="setting" id="settingFour">
        <p>Settings</p>
      </div>
    </div>
  </div>

  <div class="chatWindow"></div>

  <div class="inventory" id="inventory">
    <div class="inventorySlots">
      <div class="inventoryItem"></div>
      <div class="inventoryItem"></div>
      <div class="inventoryItem"></div>
      <div class="inventoryItem"></div>
      <div class="inventoryItem"></div>
      <div class="inventoryItem"></div>
      <div class="inventoryItem"></div>
      <div class="inventoryItem"></div>
      <div class="inventoryItem"></div>
      <div class="inventoryItem"></div>
      <div class="inventoryItem"></div>
      <div class="inventoryItem"></div>
      <div class="inventoryItem"></div>
      <div class="inventoryItem"></div>
      <div class="inventoryItem"></div>
      <div class="inventoryItem"></div>
      <div class="inventoryItem"></div>
      <div class="inventoryItem"></div>
      <div class="inventoryItem"></div>
      <div class="inventoryItem"></div>
      <div class="inventoryItem"></div>
      <div class="inventoryItem"></div>
      <div class="inventoryItem"></div>
      <div class="inventoryItem"></div>
      <div class="inventoryItem"></div>
      <div class="inventoryItem"></div>
      <div class="inventoryItem"></div>
      <div class="inventoryItem"></div>
      <div class="inventoryItem"></div>
      <div class="inventoryItem"></div>
    </div>
  </div>
</div>`;
